<template>
  <div id="app">
    <div
      v-if="user"
      class="wrapper"
    >
      <Header ref="header" />
      <Sidebar />
      <a @click="doHideSidebar">
        <router-view @saved="userEdited()" />
      </a>
    </div>
    <div v-if="!user">
      <router-view />
    </div>
  </div>
</template>

<script>
import Header from '@/components/organisms/OrHeader'
import Sidebar from '@/components/organisms/OrSidebar'
import SysUtils from '@/base/utils/SysUtils'

export default {
  name: 'App',
  components: {
    Header,
    Sidebar
  },
  data () {
    return {
    }
  },
  computed: {
    user () {
      console.debug(this.$store.state.Auth.user || localStorage.getItem('token'))
      if (this.$store.state.Auth.user || localStorage.getItem('token')) return true
      return false
    }
  },
  /*
  beforeCreate () {
    this.$store.dispatch('Auth/initUser')
      .then(user => {
        this.user_token = localStorage.getItem('token')
        if (!user) {
          localStorage.removeItem('token')
          if (this.$route.name !== 'Login' && this.$route.name !== 'M0001UserEditForm') this.$router.push('/Login')
        } else {
          if (this.$route.name === 'Login') {
            this.$router.push({name: 'Top'})
          }
        }
      })
  },
  */
  methods: {
    doHideSidebar () {
      let el = this.$refs['header']
      if (!SysUtils.isEmpty(el)) {
        el.closeNav()
      }
    },
    userEdited () {
      this.$refs.header.userEdited()
    }
  }
}
</script>

<style>
body {
  font-family: "SimHei", "Hiragino Sans GB", "Microsoft JhengHei", "Heiti", "STHeiti", "Times New Roman", Times, serif !important;
  font-size: inherit !important;
}
.btn-green {
  background-color: #29aa73 !important;
  border: 3px solid #29aa73 !important;
}
.btn-green:hover {
  background-color: #38b31a !important;
  border: 3px solid #4bcf29 !important;
}
.btn-green:active {
  background-color: #19744c !important;
  border: 3px solid #19744c !important;
}
.btn-green:focus {
  background-color: #19744c !important;
  border: 3px solid #19744c !important;
  -webkit-box-shadow: inset 0px 0px 5px #19744c !important;
  -moz-box-shadow: inset 0px 0px 5px #19744c !important;
  box-shadow: inset 0px 0px 5px #19744c !important;
}
.btn-lightblue {
  color: #415050 !important;
  background-color: #DEF1FA !important;
  border: 3px solid #DEF1FA !important;
}
.btn-lightblue:hover {
  background-color: #d5f0fd !important;
  border: 3px solid #d5f0fd !important;
}
.btn-lightblue:active {
  color: #415050 !important;
  background-color: #c5e6f7 !important;
  border: 3px solid #c5e6f7 !important;
}
.btn-lightblue:focus {
  color: #415050 !important;
  background-color: #c5e6f7 !important;
  border: 3px solid #c5e6f7 !important;
  -webkit-box-shadow: inset 0px 0px 5px #c5e6f7 !important;
  -moz-box-shadow: inset 0px 0px 5px #c5e6f7 !important;
  box-shadow: inset 0px 0px 5px #c5e6f7 !important;
}

.dg-btn--ok {
  background-color: #29aa73 !important;
  border: 3px solid #29aa73 !important;
  color: white !important
}

.dg-btn--ok:hover {
  background-color: #38b31a !important;
  border: 3px solid #4bcf29 !important;
}

.dg-btn--cancel {
  background-color: #e0a800 !important;
  border: 3px solid #e0a800 !important;
  color: white !important
}

.dg-btn--cancel:hover {
  background-color: #ffc107 !important;
  border: 3px solid #fccf48 !important;
}

.center-wrap {
  display: flex !important;
  flex-wrap: wrap !important;
  justify-content: center !important;
  align-items: center !important;
}

.link-pointer {
  cursor: pointer !important;
}

.pre-format {
  white-space: pre-line !important;
  margin-bottom: 0px !important;
  font-family: "SimHei", "Hiragino Sans GB", "Microsoft JhengHei", "Heiti", "STHeiti", "Times New Roman", Times, serif !important;
  font-size: inherit !important;
}

.custom-control-label::before,
.custom-control-label::after {
  left: -1.5rem !important
}

.modal-xl {
  max-width: 1140px !important;
}

.modal-fullscreen .modal-dialog {
  min-width: 100% !important;
  min-height: 100% !important;
  margin: 0 !important;
}

.modal-fullscreen .modal-content {
  min-height: 100vh !important;
}

.modal-small-footer .modal-footer {
  padding: 5px 16px 16px 16px !important;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.3), 0 6px 20px 0 rgba(0, 0, 0, 0.2) !important;
}

.custom-plyr-container .plyr {
  width: 100%;
  max-height: 100%;
}

:root {
  --plyr-color-main: #29aa73
}
</style>
